import { StablecoinApprovalDecisionValue } from '../../models/transfer.model';
import { StablecoinLegalEntityCreate } from '../../models/kyb.model';

export class InitStablecoinKybState {
	static readonly type: string = '[StablecoinKyb] InitStablecoinKybState';
}

export class ClearStablecoinKybState {
	static readonly type: string = '[StablecoinKyb] ClearStablecoinKybState';
}

export class GetStablecoinLegalEntities {
	static readonly type: string = '[StablecoinKyb] GetStablecoinLegalEntities';
	constructor(public refresh?: boolean) {}
}

export class CreateStablecoinLegalEntity {
	static readonly type: string = '[StablecoinKyb] CreateStablecoinLegalEntity';
	constructor(public body: StablecoinLegalEntityCreate) {}
}

export class GetStablecoinKybApplication {
	static readonly type: string = '[StablecoinKyb] GetStablecoinKybApplication';
	constructor(public entityId: string) {}
}

export class GetStablecoinKybChangeRequests {
	static readonly type: string = '[StablecoinKyb] GetStablecoinKybChangeRequests';
	constructor(public entityId: string) {}
}

export class DecideStablecoinKybChangeRequest {
	static readonly type: string = '[StablecoinKyb] DecideStablecoinKybChangeRequest';
	constructor(
		public entityId: string,
		public changeRequestId: string,
		public decision: StablecoinApprovalDecisionValue
	) {}
}
